import Cookie from 'js-cookie';
/**
 * @file: cookie操作库
 */
export const getCookie = (objName: string) => Cookie.get(objName) || '';
